/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import route from 'packages/novous_web/src/assets/icons/route.svg';
import clock from 'packages/novous_web/src/assets/icons/Clock.svg';
import deviation from 'packages/novous_web/src/assets/icons/Deviation.svg';
import check from 'packages/novous_web/src/assets/icons/check.svg';
import infoIcon from 'packages/novous_web/src/assets/icons/i.svg';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { IconButton } from '@mui/material';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import PermissionGuard from 'packages/novous_web/src/common/components/PermissionGuard';
import { PermissionSubcategory } from 'packages/novous_web/src/utils/permissionConstants';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const AddressDataTiles: React.FC<{ data: ColumnObjType | undefined }> = ({ data }) => {
  const { user } = useAuth();
  const [countData, setCountData] = useState<any>();
  const {
    data: addressCountData,
    error: addressCountError,
    loading: addressCountLoading,
    fetchData: fetchAddressCountData,
  } = useAxios<any>(`${API_ENDPOINTS.dashboard.GET_ADDRESS_COUNT}/${user?.customer_id}`, 'GET');
  useEffect(() => {
    fetchAddressCountData();
  }, [user]);

  useEffect(() => {
    setCountData(addressCountData);
  }, [addressCountData]);
  let tripTilesData = [
    {
      icon: route,
      heading: 'Total Addresses',
      value: countData?.data?.totalAddress,
      permission: {
        category: PermissionSubcategory.ADDRESSES,
        subcategory: PermissionSubcategory.TOTAL_ADDRESSES,
      },
    },
    {
      icon: clock,
      heading: 'Geofenced Addresses',
      value: '0',
      permission: {
        category: PermissionSubcategory.ADDRESSES,
        subcategory: PermissionSubcategory.GEOFENCED_ADDRESSES,
      },
    },
    {
      icon: deviation,
      heading: 'Active Trip Addresses',
      value: countData?.data?.activeTripAddress,
      permission: {
        category: PermissionSubcategory.ADDRESSES,
        subcategory: PermissionSubcategory.ACTIVE_TRIP_ADDRESSES,
      },
    },
    {
      icon: check,
      heading: 'Unused Addresses',
      value: countData?.data?.unUsedAddress,
      permission: {
        category: PermissionSubcategory.ADDRESSES,
        subcategory: PermissionSubcategory.UNUSED_ADDRESSES,
      },
    },
  ];

  const filteredTileData = useMemo(() => {
    return tripTilesData.filter((item, index) => {
      const stateName = 'Stat' + (index + 1);
      if (data) {
        if (data[stateName].name === item.heading) {
          return data[stateName].status;
        }
        return false;
      } else {
        return true;
      }
    });
  }, [data, tripTilesData]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {filteredTileData.map((tile, index) => (
        <PermissionGuard
          key={index}
          category={tile.permission.category}
          subcategory={tile.permission.subcategory}
        >
          <Paper
            sx={{ borderRadius: '12px' }}
            className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
          >
            <div className="flex items-center gap-2 w-full">
              <IconButton
                sx={(theme) => ({
                  background: theme.palette.selected,
                  padding: '4px',
                })}
              >
                <img src={tile?.icon} alt="icon" color="primary" />
              </IconButton>
              <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                <Typography
                  variant="body2"
                  noWrap // Ensures text doesn't wrap and remains in a single line
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%', // Ensures it adapts to available space
                  }}
                >
                  {tile.heading}
                </Typography>
              </div>

              <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
            </div>
            <div className="flex items-center w-full gap-2 flex-nowrap">
              <div className="invisible w-6 h-6">{tile.icon}</div>
              <Typography
                variant="h6"
                fontWeight={600}
                className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
              >
                {tile.value}
              </Typography>
            </div>
          </Paper>
        </PermissionGuard>
      ))}
    </div>
  );
};

export default AddressDataTiles;
